import { HStack, Text, theme } from "@bpba/ui-components";
import { ReactComponent as Voto } from "../../assets/icons/votoFaqs.svg";
import { VoteButton } from "./VoteButton";
import { useState } from "react";
import { PreguntaData } from "../../model/preguntas/PreguntaData";
import { FeedbackStorageManager } from "./FeedbackStorageManager";
import { useFeedbackSender } from "./useFeedbackSender";
import { FeedbackTipo } from "../../model/preguntas/FeedbackTipo";
import { RespuestaFeedback } from "../../model/preguntas/RespuestaFeedback";
import { FeedbackData } from "../../model/preguntas/FeedbackData";

type FeedbackProps = {
  preguntaData: PreguntaData;
  feedbackStorage: FeedbackStorageManager;
  tabIndex?: number;
};

export function Feedback({
  preguntaData,
  feedbackStorage,
  tabIndex,
}: FeedbackProps) {
  const [voto, setVoto] = useState<FeedbackData | undefined>(
    feedbackStorage.getByID(preguntaData.id)
  );
  const [send] = useFeedbackSender(handleValidResponse, "Feedback");

  async function onVote(feedbackTipo: FeedbackTipo) {
    if (voto) return;
    if (!feedbackStorage.validateVote(preguntaData.id)) return;

    const votoActual: FeedbackData = {
      idBtn: preguntaData.id,
      rate: feedbackTipo,
    };
    setVoto(votoActual);
    await send(votoActual);
  }

  async function onVotePositive() {
    await onVote(FeedbackTipo.Positivo);
  }

  async function onVoteNegative() {
    await onVote(FeedbackTipo.Negativo);
  }

  function handleValidResponse(
    data: RespuestaFeedback,
    votoData: FeedbackData
  ) {
    if (votoData) feedbackStorage.save(votoData);
  }
  return (
    <HStack marginTop={32} alignItems="center">
      <Text margin="0px" tabIndex={tabIndex}>
        ¿Te sirvió la información?
      </Text>
      <VoteButton
        highlightColor="#279d2e"
        selected={voto?.rate === FeedbackTipo.Positivo}
        blocked={voto !== undefined}
        onVote={onVotePositive}
        marginLeft={16}
        tabIndex={tabIndex}
        title="Sí. Presione tecla entrar para votar."
        rotate={180}
      >
        <Voto />
      </VoteButton>
      <VoteButton
        highlightColor="red"
        selected={voto?.rate === FeedbackTipo.Negativo}
        blocked={voto !== undefined}
        onVote={onVoteNegative}
        marginLeft={16}
        tabIndex={tabIndex}
        title="No. Presione tecla entrar para votar."
        marginTop={"3px"}
      >
        <Voto />
      </VoteButton>
    </HStack>
  );
}
